import * as types from './action-types';
import * as resetPasswordFormApi from '../api/reset-password-form-api';
import { beginApiCall, apiCallError } from './api-status-actions';
import * as apiResponseMessages from './api-response-messages';
import * as dataFormatHelper from './helpers/data-format-helper';

export function loadSSOResetPasswordFormDataSuccess(resetPasswordFormData) {
    return { type: types.LOAD_RESET_PASSWORD_FORM_SUCCESS, resetPasswordFormData };
}

export function loadSSOResetPasswordFormDataError() {
    return { type: types.LOAD_RESET_PASSWORD_FORM_ERROR };
}

export function handleResetPasswordSuccess(resetPasswordMessages) {
    return { type: types.RESET_PASSWORD_SUCCESS, resetPasswordMessages };
}

export function handleResetPasswordError(resetPasswordMessages) {
    return { type: types.RESET_PASSWORD_ERROR, resetPasswordMessages };
}

export function resetResetPasswordFormState() {
    return { type: types.RESET_RESET_PASSWORD_FORM_STATE };
}

export function loadSSOResetPasswordFormData() {
    return function (dispatch) {
        dispatch(beginApiCall());
        return resetPasswordFormApi.getSSOResetPasswordFormData()
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(loadSSOResetPasswordFormDataError());
                    return;
                }
                dispatch(loadSSOResetPasswordFormDataSuccess(response.data));
            })
            .catch((error) => {
                dispatch(apiCallError([error]));
                dispatch(loadSSOResetPasswordFormDataError());
                throw error;
            });
    };
}

export function handleResetPassword(userResetPasswordData, callBackUrl) {
    //eslint-disable-next-line no-unused-vars
    return function (dispatch, getState) {
        dispatch(beginApiCall());
        return resetPasswordFormApi
            .handleResetPassword(dataFormatHelper.getFormattedUserResetPasswordData(userResetPasswordData), callBackUrl)
            .then((response) => {
                if (response.hasErrors) {
                    dispatch(apiCallError([response.errorMessage]));
                    dispatch(handleResetPasswordError([response.errorMessage]));
                    return;
                }

                dispatch(handleResetPasswordSuccess([apiResponseMessages.RESET_PASSWORD_SUCCESSFULLY]));
            })
            .catch((error) => {
                dispatch(handleResetPasswordError([apiResponseMessages.SERVER_ERROR_MESSAGE]));
                dispatch(apiCallError([error]));
                throw error;
            });
    };
}
